import React, { useCallback } from 'react';
import { LabelValue, LabelValueAcceptedBy } from 'graphql/types';
import { TimesheetLabel } from 'modules/timesheet-labels/labelSchema';
import { TextFieldChip } from 'modules/common';

type SelectChipProps = {
  label: TimesheetLabel;
  onChange: (
    value: LabelValue | null,
    acceptedBy: LabelValueAcceptedBy | null
  ) => void;
};
export const NumericChip: React.FC<SelectChipProps> = ({
  label,
  onChange
}: SelectChipProps) => {
  const handleDelete = useCallback(() => {
    onChange(null, null);
  }, [onChange]);
  const acceptSuggestionHandler = useCallback(
    (value: LabelValue | null) => onChange(value, LabelValueAcceptedBy.User),
    [onChange]
  );
  return (
    <div data-testid={'numeric-chip'}>
      <TextFieldChip
        label={label}
        onChange={onChange}
        type={'number'}
        handleDelete={handleDelete}
        acceptSuggestion={acceptSuggestionHandler}
      />
    </div>
  );
};
